import { render, staticRenderFns } from "./AppointmentTypeButton.vue?vue&type=template&id=d0ba5f90&scoped=true&"
import script from "./AppointmentTypeButton.vue?vue&type=script&lang=js&"
export * from "./AppointmentTypeButton.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTypeButton.vue?vue&type=style&index=0&id=d0ba5f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ba5f90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
